<script>
  import { trapFocus } from '../trapFocus.js'

  export let mediaIndex = 0
  export let isActive = false
  export let media = []
  export let closeModal
  const ENTER_KEY = 13
  const nextDisabled = false
  const previousDisabled = false

  const next = () => {
    mediaIndex = mediaIndex < media.length - 1 ? mediaIndex + 1 : mediaIndex
  }

  const prev = () => {
    mediaIndex = mediaIndex > 0 ? mediaIndex - 1 : mediaIndex
  }

  const close = () => {
    mediaIndex = 0
    closeModal()
  }
</script>

<style>
  :global(._1ijXU) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    z-index: 5000;
    overflow: auto;
  }

  :global(._3A1Xu) {
    padding: 10px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
    position: relative;
  }

  :global(._2m8gO) {
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 18px;
    margin-left: 10px;
  }

  :global(._3waIs) {
    z-index: 2;
    position: absolute;
    top: 10px;
    right: 10px;
    transform: scale(2);
    background: url('https://dashboard2.kudobuzz.com/static/media/icon-close.5b38ea87.svg');
    background-repeat: no-repeat;
    display: inline-block;
    padding: 16px;
    background-position: center;
    margin: 0 0 0 auto;
    border: none;
  }

  :global(._3waIs,)
  :global(._1s6s7,)
  :global(._1p8a6) {
    font-size: 14px;
    cursor: pointer;
    padding: 12px 20px;
    border-radius: 4px;
    position: relative;
  }

  :global(._28Lud) {
    z-index: 9;
    position: relative;
    margin: auto;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 500px;
    height: 85%;
    overflow: hidden;
    border-radius: 4px;
    background: transparent !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  :global(._2yu58) {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 2;
    box-sizing: border-box;
    margin: auto;
  }

  :global(._19vcZ) {
    display: flex;
    align-items: center;
    background: #fff;
    box-shadow: 0 8px 20px 0 rgba(16, 37, 62, 0.22),
      0 0 10px 0 rgba(0, 0, 0, 0.09);
    border-radius: 4px;
    margin: auto;
  }

  :global(._1s6s7) {
    content: url(https://statisc2test.kudobuzz.com/icons/icon-back.svg);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 20px;
    background: #fff;
    transition: 0.2s;
    width: 14px;
    transform: scale(-1);
  }

  :global(._1p8a6) {
    content: url(https://statisc2test.kudobuzz.com/icons/icon-back.svg);
    height: 20px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background: #fff;
    transition: 0.2s;
    width: 14px;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.3;
  }

  :global(._3KYsh) {
    margin: 0 30px;
    color: #696c85;
  }

  :global(.ZfQWd) {
    opacity: 0.6;
    background: #34495e;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  :global(._1s6s7:hover,)
  :global(._1p8a6:hover) {
    background: #dfe5eb;
  }

  :global(._2DpTL) {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
  }
</style>

{#if isActive}
  <div class="_1ijXU" class:active={isActive} use:trapFocus>
    <!-- svelte-ignore a11y-autofocus -->
    <div
      aria-label="Review media"
      aria-modal="true"
      role="dialog"
      aria-atomic="false"
      aria-live="polite"
      tabindex={0}
      autofocus
      class="_3A1Xu">
      <div class="_2m8gO">
        <button
          aria-label="close modal"
          class="_3waIs"
          on:click={close} />
      </div>

      <div class="_28Lud" id="mediaContent">
        {#if media[mediaIndex].media_type === 'image'}
          <img
            src={media[mediaIndex].url}
            alt= 'review media'
            class="_2DpTL" />
        {:else}
          <video
            class=" review-media"
            src="{media[mediaIndex].url}#t=0.1"
            controls>
            <track kind="captions" />
          </video>
        {/if}
      </div>

      <div class="_2yu58">
        <div class="_19vcZ">
          <div
            role="button"
            aria-label="click to view previous media"
            tabindex="0"
            class="_1p8a6"
            class:disabled={previousDisabled}
            on:click={prev}
            on:keyup={e => (e.keyCode === ENTER_KEY ? prev() : '')}>
            Previous
          </div>
          <div class="_3KYsh">{mediaIndex + 1} of {media.length}</div>
          <div
            role="button"
            aria-label="click to view next media"
            tabindex="0"
            class="_1s6s7"
            class:disabled={nextDisabled}
            on:click={next}
            on:keyup={e => (e.keyCode === ENTER_KEY ? next() : '')}>
            Next
          </div>
        </div>
      </div>
    </div>
    <div class="ZfQWd" on:click={close} />
  </div>
{/if}

<slot />
